import { getAllCategories, getSubCategories, updateWord } from "@api/Vocabulary";
import { useCustomQuery } from "../../../lib/TansTack/hooks/userCustomQuery.hook";
import { useQueryClient } from "@tanstack/react-query";
import { returnWarningTypeImage } from "@containers/VocabularySeminaryContainer/functions/VocabularyFunctions";
import { returnFlag } from "functions/Functions";
import { useEffect, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import Modal from "react-bootstrap/Modal";
import "./EditWordModal.scss";
import { WrenchIcon } from "assets/Imports";
import useVocabulary from "@hooks/useVocabulary";
import { SpinnerCustom } from "@components/Spinner/SpinnerMyAccountView";
import { useVocabularySeminaryContext } from "contexts/VocabularySeminaryContext";
import { useAuth } from "@hooks/useAuth";
import { IWord } from "interfaces/DefaultQuizzes/DefaultQuizzes.interface";
import { processMeanings } from "functions/Words/words.functions";
interface IEditWordModal {
	show?: boolean;
	onHide?: () => void;
	word_data_id?: number | null;
	word?: any;
	getQuiz?: ((value: boolean) => void) | undefined;
	getWords?: (() => void) | undefined;
	getAllWordReports?: (() => void) | undefined;
	language?: string;
	setCountRefresh?: (count: number) => void;
	countRefresh?: number;
	readOnly?: boolean;
}
export function EditWordModal(props: IEditWordModal) {
	const { getWordData } = useVocabulary();
	const queryClient = useQueryClient();
	const [word, setWord] = useState(props.word);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSave, setLoadingSave] = useState<boolean>(false);
	const [isProcessed, setIsProcessed] = useState<boolean>(false); // Flag para evitar procesamiento múltiple
	const { data: categoriesData, isLoading: isLoadingCategories } = useCustomQuery(
		"categories",
		getAllCategories,
		{}
	);
	const { data: subCategoriesData, isLoading: isLoadingSubCategories } = useCustomQuery(
		"subcategories",
		getSubCategories,
		{}
	);
	const { data: wordData, isLoading: isLoadingWordData } = useCustomQuery(
		`word-data-${props.word_data_id}`,
		() => getWordData(props.word_data_id || 0),
		{}, // params vacío
		{
			enabled: props.show && !!props.word_data_id, // Solo ejecutar cuando tengamos word_data_id y el modal esté abierto
			refetchOnMount: true, // Refrescar siempre al montar
			staleTime: 0, // Considerar los datos como obsoletos inmediatamente
		}
	);

	// Procesamos los datos cuando llegan
	const categories =
		categoriesData?.categories?.sort((a: any, b: any) =>
			a.family > b.family ? 1 : a.family < b.family ? -1 : 0
		) || [];

	const subCategories =
		subCategoriesData?.categories?.sort((a: any, b: any) =>
			a.sub_family > b.sub_family ? 1 : a.sub_family < b.sub_family ? -1 : 0
		) || [];

	const [warningType, setWarningType] = useState<string>("warning");
	const [editCategory, setEditCategory] = useState<boolean>(false);
	const [editSubCategory, setEditSubCategory] = useState<boolean>(false);
	const [value, setValue] = useState<string>(""); // Content inside React Quill 'avisos'
	const [value2, setValue2] = useState<string>(""); // Content inside React Quill 'aviso extendido'
	const [warn, setwarn] = useState<Array<string>>([
		"warning",
		"memory",
		"grammar",
		"advice",
		"fake_friend",
		"similarity",
		"pronunciation",
		"did_YouKnow",
	]);
	const { getSeminary, view } = useVocabularySeminaryContext();
	let user = useAuth().user;
	var Font = Quill.import("formats/font");
	Font.whitelist = ["cirilico"];
	Quill.register(Font, true);
	var Block = Quill.import("blots/block");
	Block.tagName = "p";
	Block.className = "pre";
	Quill.register(Block, true);
	var toolbarOptions = [
		[{ size: ["small", false, "large", "huge"] }], // custom dropdown
		[{ color: [] }, { background: [] }], // dropdown with defaults from theme
		["bold", "italic", "underline", "strike"],
		[{ indent: "-1" }, { indent: "+1" }], // toggled buttons

		["clean"], // remove formatting button
	];

	const onChange = (e) => {
		const { name, value } = e.target;

		// Validación especial para el campo meaning para evitar duplicaciones
		if (name === "meaning") {
			// Si el valor ya contiene el separador |, no duplicar
			const cleanValue = value.replace(/\|\|+/g, "|"); // Reemplazar múltiples | consecutivos con uno solo
			setWord({ ...word, [name]: cleanValue });
		} else {
			setWord({ ...word, [name]: value });
		}
	};

	const onChangeSubCategories = (e) => {
		const newValue = parseInt(e.target.value);
		const tempSubCat = JSON.parse(JSON.stringify(word.sub_category));
		const index = tempSubCat.findIndex((e) => e === newValue);

		if (index === -1) {
			tempSubCat.push(newValue);
		} else {
			tempSubCat.splice(index, 1);
		}
		setWord({ ...word, [e.target.name]: tempSubCat });
	};

	// Función getCategories eliminada - ahora usamos React Query arriba
	const processSeminaries = (seminarios: any): number[] => {
		let seminariesArray: number[] = [];
		if (seminarios) {
			if (typeof seminarios === "string") {
				// Si es string, convertir a array de números
				seminariesArray = seminarios
					.split(",")
					.map((s) => parseInt(s.trim()))
					.filter((n) => !isNaN(n) && n >= 0 && n <= 60);
			} else if (Array.isArray(word.seminarios)) {
				// Si ya es array, convertir a números
				seminariesArray = word.seminarios
					.map((s) => (typeof s === "number" ? s : parseInt(s)))
					.filter((n) => !isNaN(n) && n >= 0 && n <= 60);
			}
		}
		return seminariesArray;
	};
	const getWord = async (categories_temp, sub_categories_temp) => {
		if (word.native_word !== undefined && loading && !isProcessed) {
			console.log("🔍 EditWordModal - Processing word, meaning before:", word.meaning);

			setIsProcessed(true); // Marcar como procesado inmediatamente

			let meaning = "";

			// Verificar si meaning ya es un string (viene del Excel) o es un array
			if (Array.isArray(word.meaning)) {
				// Si es array, convertir a string con separador |
				meaning = word.meaning.join("|");
			} else if (typeof word.meaning === "string") {
				// Si ya es string (como cuando viene del Excel), usarlo directamente
				meaning = word.meaning;
			}

			// Se guardan los ids para poder utilizarlo de esta manera en los selects
			const subCategoriesTemp: Array<any> = [];

			// Verificar si sub_category es array de objetos (nombres) o array de IDs
			if (Array.isArray(word.sub_category)) {
				word.sub_category.forEach((sub) => {
					if (sub !== null && sub !== undefined && sub !== "sin subcategorías") {
						// Si es un número, ya es un ID
						if (typeof sub === "number") {
							subCategoriesTemp.push(sub);
						} else if (typeof sub === "string") {
							// Si es string, buscar el ID correspondiente
							const subCatFound = sub_categories_temp.find(
								(e) => e.sub_family === sub || e.sub_family.toLowerCase() === sub.toLowerCase()
							);
							if (subCatFound) {
								subCategoriesTemp.push(subCatFound.id);
							}
						}
					}
				});
			}

			// Procesar la categoría
			let categoryId = word.category;
			if (typeof word.category === "string") {
				// Buscar por nombre de categoría
				const categoryFound = categories_temp.find(
					(e) =>
						e.family === word.category ||
						e.singular === word.category ||
						e.family.toLowerCase() === word.category.toLowerCase() ||
						e.singular.toLowerCase() === word.category.toLowerCase()
				);
				categoryId = categoryFound ? categoryFound.id : word.category;
			} else if (Array.isArray(word.category) && word.category.length > 0) {
				// Si es array, tomar el primer elemento
				const categoryName = word.category[0];
				const categoryFound = categories_temp.find(
					(e) =>
						e.family === categoryName ||
						e.singular === categoryName ||
						e.family.toLowerCase() === categoryName.toLowerCase() ||
						e.singular.toLowerCase() === categoryName.toLowerCase()
				);
				categoryId = categoryFound ? categoryFound.id : categoryName;
			} else if (typeof word.category === "number") {
				// Si ya es un ID numérico, usarlo directamente
				categoryId = word.category;
			}

			// Procesar el campo "aparece en material" (paper)
			let paperValue = 0;
			if (word.paper !== undefined && word.paper !== null) {
				if (typeof word.paper === "number") {
					paperValue = word.paper;
				} else if (typeof word.paper === "string") {
					const paperStr = word.paper.toLowerCase().trim();
					// Manejar diferentes formatos del Excel: "sí", "si", "yes", "1", "true"
					if (
						paperStr === "sí" ||
						paperStr === "si" ||
						paperStr === "yes" ||
						paperStr === "1" ||
						paperStr === "true" ||
						paperStr === "verdadero"
					) {
						paperValue = 1;
					} else if (
						paperStr === "no" ||
						paperStr === "0" ||
						paperStr === "false" ||
						paperStr === "falso"
					) {
						paperValue = 0;
					} else {
						// Intentar convertir a número
						const numValue = parseInt(paperStr);
						paperValue = isNaN(numValue) ? 0 : numValue;
					}
				} else if (typeof word.paper === "boolean") {
					paperValue = word.paper ? 1 : 0;
				}
			}

			// Procesar seminarios
			let seminariesArray: number[] = processSeminaries(word.seminarios);
			console.log("🔍 EditWordModal - Processing complete, meaning after:", meaning);
			const data = {
				...word,
				meaning: meaning,
				category: categoryId,
				sub_category: subCategoriesTemp,
				paper: paperValue,
				seminarios: seminariesArray,
			};
			setWord(data);

			setLoading(false);
		}
	};

	// getWordById eliminada - ahora usamos React Query arriba

	const saveWord = async () => {
		if (!word) {
			return;
		}
		setLoadingSave(true);

		// Procesar meanings correctamente y limpiar duplicados
		let meanings: string[] = [];
		if (typeof word.meaning === "string") {
			// Si es string, dividir por | para obtener array
			meanings = word.meaning
				.split("|")
				.map((meaning) => meaning.trim())
				.filter((meaning) => meaning !== "");

			// Eliminar duplicados usando Set
			meanings = Array.from(new Set(meanings));
		} else if (Array.isArray(word.meaning)) {
			// Si ya es array, usarlo directamente y eliminar duplicados
			meanings = word.meaning
				.map((meaning) => (meaning ? meaning.toString().trim() : ""))
				.filter((meaning) => meaning !== "");

			// Eliminar duplicados usando Set
			meanings = Array.from(new Set(meanings));
		}

		console.log("🔍 EditWordModal - Saving meanings (before dedup):", word.meaning);
		console.log("🔍 EditWordModal - Saving meanings (after dedup):", meanings);

		const languageIdValue = Number(word.language_Id ?? word.language_id ?? word.languageId);
		if (Number.isNaN(languageIdValue)) {
			console.error("🔍 EditWordModal - Missing language_Id for word", word);
			alert(
				"No se pudo determinar el idioma de la palabra. Recarga la página e inténtalo de nuevo."
			);
			setLoadingSave(false);
			return;
		}

		const familyIdValue = Number(Array.isArray(word.category) ? word.category[0] : word.category);
		if (Number.isNaN(familyIdValue)) {
			console.error("🔍 EditWordModal - Invalid family_id for word", word);
			alert(
				"No se pudo determinar la categoría actual. Revisa la categoría seleccionada e inténtalo nuevamente."
			);
			setLoadingSave(false);
			return;
		}

		const normalizedSubCategories = Array.isArray(word.sub_category)
			? word.sub_category
					.filter((sub) => sub !== null && sub !== undefined && sub !== "")
					.map((sub) => Number(sub))
					.filter((sub) => !Number.isNaN(sub))
			: [];
		const seminariesArray: number[] = processSeminaries(props.word?.seminarios || []);

		const id_significado = await processMeanings(meanings, languageIdValue);
		const data: Partial<IWord> = {
			id: word.word_id,
			word_data_id: word.id,
			palabra: word.native_word,
			significado: meanings,

			categories_ids: [familyIdValue],
			categories_ids_del: [familyIdValue],
			id_significado: id_significado,
			subcategories_ids: normalizedSubCategories,
			// dificultad: "0.89887755",

			advertencia: word.warning || "",
			memoria: word.memory || "",
			gramatica: word.grammar || "",
			consejo: word.advice || "",
			idioma: languageIdValue,
			falso_amigo: word.fake_friend || "",
			similitud: word.similarity || "",
			palabra_opcional: word.optional_word === "" ? null : word.optional_word,
			sub_categoria: normalizedSubCategories,
			pronunciacion: word.pronunciation || "",
			sabias_que: word.did_YouKnow || "",
			paper: Number(word.paper ?? 0),
			seminarios: seminariesArray, // ✅ Cambiado de 'seminarios' a 'seminaries'
		};
		await updateWord(data)
			.then((res) => {
				console.log("🔍 EditWordModal - Update successful:", res);

				// Invalidación agresiva y refetch inmediato de todo lo relacionado con vocabulario/words
				// Lo envolvemos en una micro-tarea para permitir que React termine el ciclo actual
				setTimeout(async () => {
					const predicates: Array<(k: any) => boolean> = [
						// Cubre keys simples tipo 'vocabulary', 'categories', etc.
						(key) => typeof key === "string" && /^(vocabulary|categories|subcategories)$/.test(key),
						// Cubre keys que contengan términos relevantes
						(key) =>
							typeof key === "string" &&
							/(word|words|quiz|report|search|sem[ií]nary|vocab)/i.test(key),
					];

					// Invalidar palabra específica primero (para asegurar refetch puntual)
					if (props.word_data_id) {
						await queryClient.invalidateQueries({ queryKey: [`word-data-${props.word_data_id}`] });
					}

					// Invalidar grupos explícitos conocidos
					await Promise.all([
						queryClient.invalidateQueries({ queryKey: ["vocabulary"] }),
						queryClient.invalidateQueries({ queryKey: ["categories"] }),
						queryClient.invalidateQueries({ queryKey: ["subcategories"] }),
					]);

					// Invalidar seminarios (pattern en cualquier posición del key principal)
					await queryClient.invalidateQueries({
						predicate: (query) => {
							const root = query.queryKey?.[0];
							return Boolean(root && typeof root === "string" && /seminar(y|io|i)/i.test(root));
						},
					});

					// Invalidación amplia basada en predicados para keys complejas (arrays)
					await queryClient.invalidateQueries({
						predicate: (query) => {
							return query.queryKey?.some?.((segment: any) => predicates.some((p) => p(segment)));
						},
					});

					// Opcional: forzar refetch de cualquier lista de palabras en pantalla que pueda usar paginación o filtros
					await queryClient.refetchQueries({
						predicate: (query) => {
							return query.queryKey?.some?.(
								(segment: any) =>
									typeof segment === "string" && /(vocab|word|words|quiz)/i.test(segment)
							);
						},
						type: "active",
					});
				}, 50);

				// Call the getWords function from props to refetch data
				if (props.getQuiz !== undefined) {
					props.getQuiz(true);
				} else if (props.getWords !== undefined) {
					props.getWords();
				} else if (props.countRefresh !== undefined) {
					if (props.setCountRefresh) {
						props.setCountRefresh(props.countRefresh + 1);
					}
				} else if (props.getAllWordReports) {
					props.getAllWordReports();
				} else if (getSeminary !== undefined && view === 1) {
					getSeminary();
				}
				onHide();
				setLoadingSave(false);
			})
			.catch((error) => {
				console.error("🔍 EditWordModal - Update failed:", error);
				alert("Ha ocurrido un error.");
				setLoadingSave(false);
			});
	};

	function returnSubCatValues(sub_categories: Array<any>) {
		let value = "";
		sub_categories.map((subCat, i) => {
			if (subCategories.filter((e) => e.id === subCat).length > 0) {
				value +=
					subCategories.filter((e) => e.id === subCat)[0].sub_family +
					(i < sub_categories.length - 1 ? ", " : "");
			}
		});
		return value;
	}

	const onHide = () => {
		setWord(undefined);
		setLoading(true);
		setIsProcessed(false); // Reset del flag de procesamiento
		setValue("");
		setValue2("");

		// Limpiar cache cuando se cierre el modal para evitar datos obsoletos
		if (props.word_data_id) {
			queryClient.removeQueries({
				queryKey: [`word-data-${props.word_data_id}`],
			});
		}
		if (props.onHide) {
			props.onHide();
		}
	};

	// useEffect para getCategories eliminado - React Query maneja la carga automáticamente

	useEffect(() => {
		if (
			word !== undefined &&
			word !== null &&
			props.show &&
			loading &&
			!!categories.length &&
			!!subCategories.length
		) {
			getWord(categories, subCategories);
		}
	}, [props.show, word, categories, subCategories, loading]);

	// useEffect para establecer la palabra desde React Query o props
	useEffect(() => {
		if (props.show && props.word_data_id && wordData && !isLoadingWordData) {
			console.log("🔍 EditWordModal - Setting word from API");
			setLoading(true);
			setWord(wordData);
			setIsProcessed(false); // Reset del flag de procesamiento
		} else if (props.show && props.word !== undefined) {
			console.log("🔍 EditWordModal - Setting word from props");
			setLoading(true);
			setWord(props.word);
			setIsProcessed(false); // Reset del flag de procesamiento
		}
	}, [props.show, wordData, isLoadingWordData, props.word]);

	// useEffect para limpiar cuando se cierre el modal
	useEffect(() => {
		if (!props.show) {
			setWord(undefined);
			setLoading(true);
			setIsProcessed(false); // Reset del flag de procesamiento
			setValue("");
			setValue2("");
			setWarningType("warning");
		}
	}, [props.show]);

	useEffect(() => {
		if (word && value !== word[warningType]) {
			setWord({ ...word, [warningType]: value });
		}
	}, [value, warningType]);

	// useEffect para actualizar el valor del ReactQuill cuando cambia el tipo de nota
	useEffect(() => {
		if (word && word[warningType] !== undefined) {
			setValue(word[warningType] || "");
		}
	}, [warningType, word]);

	return (
		<Modal
			show={props.show}
			onHide={onHide}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			className="edit-word-in-test-modal"
			centered
		>
			<Modal.Header closeButton>
				<img className="llave-img" src={WrenchIcon} alt="icono de llave inglesa" />
				<Modal.Title id="contained-modal-title-vcenter">Editar término</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{loading ||
				isLoadingCategories ||
				isLoadingSubCategories ||
				(props.word_data_id && isLoadingWordData) ? (
					<SpinnerCustom height={400} />
				) : (
					<div className="container">
						<div className="row">
							<div className="col-sm mb-3">
								<label htmlFor="native_word" className="form-label">
									{word.language === "chinese" ? "Pinyin" : "Término"}
									{returnFlag(word.language)}
								</label>
								<input
									type="text"
									className="form-control"
									id="native_word"
									name="native_word"
									value={word.native_word}
									onChange={onChange}
								/>
							</div>
							<div className="col-sm mb-3">
								<label htmlFor="native_word" className="form-label">
									Significado + variaciones
								</label>
								<input
									type="text"
									className="form-control"
									id="meaning"
									name="meaning"
									value={word.meaning}
									onChange={onChange}
								/>
								<legend className="mt-2" style={{ fontSize: "0.875rem" }}>
									El carácter | es el separador de palabras.
								</legend>
							</div>
						</div>
						{(word.language === "chinese" || word.language === "japanese") && (
							<div className="row">
								<div className="col-sm mb-3">
									<label htmlFor="native_word" className="form-label">
										{word.language === "chinese" && "Kanzi"}
										{word.language === "japanese" && "Kanji"}
									</label>
									<input
										type="text"
										className="form-control"
										id="optional_word"
										name="optional_word"
										value={word.optional_word === null ? "" : word.optional_word}
										onChange={onChange}
									/>
								</div>
								<div className="col-sm mb-3"></div>
							</div>
						)}
						<div className="row">
							<div className="col-sm mb-3">
								<label htmlFor="warning" className="form-label d-flex align-items-center">
									Categoría
									<img
										className="llave-img"
										src={WrenchIcon}
										alt="icono de llave inglesa"
										role={"button"}
										onClick={() => setEditCategory(!editCategory)}
									/>
								</label>
								{editCategory ? (
									<div className="warning-note-inputs-container ">
										<select
											value={word.category}
											className="form-control w-100"
											name="category"
											onChange={onChange}
											aria-label="Default select example"
										>
											<option value="none">Seleccionar una categoría</option>
											{categories &&
												categories.length > 0 &&
												categories.map((category, index) => {
													if (category.singular !== "") {
														return (
															<option value={category.id} key={"category-option-select-" + index}>
																{category.singular}
															</option>
														);
													}
												})}
										</select>
									</div>
								) : (
									<div className="warning-note-inputs-container readOnly ">
										<input
											type="text"
											className="form-control border-0"
											id="category"
											name="category"
											value={
												categories.filter((e) => e.id === parseInt(word.category.toString()))[0]
													?.singular
											}
											disabled
										/>
									</div>
								)}
							</div>
							<div className="col-sm mb-3">
								<label htmlFor="warning" className="form-label d-flex align-items-center">
									Sub categorías
									<img
										className="llave-img"
										src={WrenchIcon}
										alt="icono de llave inglesa"
										role={"button"}
										onClick={() => setEditSubCategory(!editSubCategory)}
									/>
									{editSubCategory && (
										<a
											style={{ cursor: "pointer" }}
											className="clean-subcategories "
											onClick={() => {
												editSubCategory && (word.sub_category = []);
											}}
										>
											Limpiar
										</a>
									)}
								</label>
								{editSubCategory ? (
									<div className="warning-note-inputs-container ">
										<select
											value={word.sub_category}
											multiple
											className="form-control w-100"
											name="sub_category"
											onChange={onChangeSubCategories}
											aria-label="Default select example"
										>
											<option value="none">Seleccionar una categoría</option>
											{subCategories.length > 0 &&
												subCategories.map((subCategory, index) => {
													return (
														<option
															value={subCategory.id}
															key={"sub-category-option-select-" + index}
														>
															{subCategory.sub_family}
														</option>
													);
												})}
										</select>
									</div>
								) : (
									<div className="warning-note-inputs-container readOnly ">
										<input
											type="text"
											className="form-control border-0"
											id="category"
											name="category"
											value={returnSubCatValues(word.sub_category)}
											disabled
										/>
									</div>
								)}
							</div>
						</div>
						{/* Campo de Seminarios */}

						<div className="row">
							<div className="col-sm mb-3">
								<label htmlFor="warning" className="form-label">
									Notas
								</label>
								<div className="warning-note-inputs-container">
									{returnWarningTypeImage(warningType)}
									<select
										className="form-control"
										value={warningType}
										onChange={(e) => setWarningType(e.target.value)}
										name="warningType"
										id="warningType"
									>
										<option value="warning">Advertencia</option>
										<option value="memory">Memoria</option>
										<option value="grammar">Gramática</option>
										<option value="advice">Consejo</option>
										<option value="fake_friend">Falso amigo</option>
										<option value="similarity">Similitud</option>
										<option value="pronunciation">Pronunciación</option>
										<option value="did_YouKnow">¿Sabías que...?</option>
									</select>
								</div>
								<div>
									{warn.map((val: any, index: number) => {
										if (val === warningType) {
											return (
												<ReactQuill
													modules={{ toolbar: toolbarOptions }}
													theme="snow"
													defaultValue={word[warningType]}
													onChange={setValue}
													key={"textQuill " + index}
												/>
											);
										}
									})}
								</div>
							</div>
						</div>
					</div>
				)}
			</Modal.Body>
			{!props.readOnly && (
				<Modal.Footer className="justify-content-center justify-content-sm-between">
					<button className="action-btn secondary-btn-bg" onClick={props.onHide}>
						Cerrar
					</button>
					<button
						disabled={loadingSave}
						className={`action-btn linear-bg ${loadingSave ? "disabled-btn" : ""}`}
						onClick={saveWord}
					>
						Guardar
					</button>
				</Modal.Footer>
			)}
		</Modal>
	);
}
